export const OPEN_SNACKBAR = 'OPEN_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';

export default {
  OPEN_SNACKBAR,
  CLOSE_SNACKBAR,
};



// WEBPACK FOOTER //
// ./src/store/app/types.js